import mediumZoom from 'medium-zoom';

/**
 * Responsive zoom margins:
 *
 * Mobile  (< 640px)   — small fixed margin, image fills screen
 * Tablet  (640–1023px) — 25% margin each side → zoomed image ~50vw
 * Desktop (≥ 1024px)  — clamp zoomed width to 900–1200px, centred
 */
function zoomOptions() {
    const vw = window.innerWidth;

    if (vw < 640) {
        return { margin: 0 };
    }

    if (vw < 1024) {
        return { margin: Math.round(vw * 0.25) };
    }

    // Desktop: target a zoomed width clamped between 900 and 1200px
    const targetWidth = Math.min(1200, Math.max(900, Math.round(vw * 0.65)));
    return { margin: Math.round((vw - targetWidth) / 3) };
}

// Script is deferred — DOM is ready, no event listener needed.
// Images are server-rendered PHP so Alpine timing is irrelevant.
(function () {
    const images = document.querySelectorAll('[data-zoom]');
    if (!images.length) return;

    const zoom = mediumZoom('[data-zoom]', {
        background: 'rgba(0, 0, 0, 0.88)',
        scrollOffset: 40,
        margin: zoomOptions().margin,
    });

    // Recalculate margins on resize / orientation change
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => zoom.update(zoomOptions()), 200);
    });
}());
